import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import HamburgerDrawerButton from "./HamburgerDrawerButton";
import { WMKLink } from "wmk-lib";
import Theme from "../../../../vars/ThemeOptions";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { R } from "../../../common/";
import get from "lodash/get";

const menuItems = {
  ContentfulLinks: WMKLink,
  HamburgerButton: HamburgerDrawerButton,
};

const Styled = {};
Styled.DrawerLevel1 = styled(Row)`
  top: 1rem;
  right: 1rem;
  width: calc(100vw - 1rem);
  z-index: 1;
`;
Styled.DrawerLevel2 = styled(Row)`
  top: 2rem;
  width: calc(100vw - 2rem);
  z-index: 2;
  transition: all 0.3s ease;
`;
Styled.DrawerLevel3 = styled(Row)`
  top: 3rem;
  width: calc(100vw - 3rem);
  z-index: 3;
  transition: all 0.3s ease;
`;
Styled.MenuItem = styled(Col)`
  flex-grow: 0;
`;
Styled.Menus = styled(Container)`
  .menu-drawer {
    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.5);
    background: white;
    position: absolute;
    padding: 10vh 0 0 10vh;
    & > .col {
      flex-grow: 0;
      font-size: 1.5rem;
      border-bottom: 2px solid ${Theme.hex("concrete")};
      padding-bottom: 0.25rem;
      margin-bottom: 0.5rem;
      @media screen and (max-width: ${Theme.break.sm}px) {
        font-size: 1.25rem;
      }
    }
  }
  button,
  a {
    background: none;
    border: none;
    appearance: none;
    padding: 0;
    color: ${Theme.hex("blue")};
    :hover {
      text-decoration: none;
      color: ${Theme.hex("green")};
    }
    @media screen {
      :focus {
        outline: none;
      }
    }
  }
`;

export const DrawerTopics = ({
  menus,
  headerHeight,
  activeDrawer,
  setActiveDrawer,
  slug,
  parentChapter,
}) => {
  const [activeTopic, setActiveTopic] = useState(null);
  const handleGoBack = () => {
    setActiveDrawer("pages");
  };
  const handleTopics = (chapter) => {
    setActiveTopic(menus["topics"][chapter]);
  };
  const chapterMenus = menus["chapters"];
  const exploreChapter = chapterMenus
    .map((link) => {
      return link.slug === parentChapter && link;
    })
    .filter((slug) => slug)[0];
  const closeTopic = () => {
    setActiveTopic(null);
  };
  useEffect(() => {
    setActiveDrawer("chapters");
    setActiveTopic(menus["topics"][parentChapter]);
  }, [parentChapter, menus, setActiveDrawer]);
  return (
    <Styled.Menus>
      <Styled.DrawerLevel1
        className="flex-column menu-drawer"
        style={{
          minHeight: `calc(100vh - ${headerHeight}px - 1rem)`,
          //top: `calc(${headerHeight}px + 1rem`,
        }}
      >
        {menus.pages.map((link, i) => {
          const MenuItem = menuItems[link.__typename];
          const path = link.entry && link.entry.slug;
          return (
            MenuItem && (
              <Styled.MenuItem key={link.title + i}>
                <MenuItem
                  action={() => link.action("chapters")}
                  to={"/" + path}
                >
                  {link.title}
                </MenuItem>
              </Styled.MenuItem>
            )
          );
        })}
      </Styled.DrawerLevel1>
      <Styled.DrawerLevel2
        className="flex-column menu-drawer"
        style={{
          right: activeDrawer === "chapters" ? "1rem" : "-100%",
          minHeight: `calc(100vh - ${headerHeight}px - 2rem)`,
        }}
      >
        <Styled.MenuItem>
          <button onClick={handleGoBack}>
            <IoMdArrowBack /> Main Menu
          </button>
        </Styled.MenuItem>
        <Styled.MenuItem>
          <button onClick={() => handleTopics(parentChapter)}>
            Explore {get(exploreChapter, `title`)} <IoMdArrowForward />
          </button>
        </Styled.MenuItem>
        {chapterMenus.map((link, i) => {
          return link.slug !== parentChapter ? (
            <Col key={"chapter-link" + i}>
              <WMKLink to={"/" + link.slug}>{link.title}</WMKLink>
            </Col>
          ) : null;
        })}
      </Styled.DrawerLevel2>
      <Styled.DrawerLevel3
        className="flex-column menu-drawer"
        style={{
          right: activeTopic ? "1rem" : "-100%",
          minHeight: `calc(100vh - ${headerHeight}px - 3rem)`,
        }}
      >
        <Styled.MenuItem>
          <button onClick={closeTopic}>
            <IoMdArrowBack /> Back to Chapters
          </button>
        </Styled.MenuItem>
        {activeTopic
          ? activeTopic.map((link, i) => {
              return link.slug !== slug ? (
                <Col key={"topic-" + link.slug + i}>
                  <WMKLink to={`/${parentChapter}/${link.slug}`}>
                    <R>{link.title}</R>
                  </WMKLink>
                </Col>
              ) : null;
            })
          : null}
      </Styled.DrawerLevel3>
    </Styled.Menus>
  );
};

export const DrawerChapters = ({
  menus,
  headerHeight,
  activeDrawer,
  setActiveDrawer,
  pageType,
  slug,
}) => {
  const [activeTopic, setActiveTopic] = useState(null);
  const handleGoBack = () => {
    setActiveDrawer("pages");
  };
  const chapterMenus = menus[pageType];
  const exploreChapter = chapterMenus
    .map((link) => {
      return link.slug === slug && link;
    })
    .filter((slug) => slug)[0];
  const closeTopic = () => {
    setActiveTopic(null);
  };
  const handleTopics = (chapter) => {
    setActiveTopic(menus["topics"][chapter]);
  };
  //console.log(exploreChapter);
  return (
    <Styled.Menus>
      <DrawerLevel1
        headerHeight={headerHeight}
        activeMenu={menus["pages"]}
        setActiveDrawer={setActiveDrawer}
        pageType={pageType}
      />
      <Styled.DrawerLevel2
        className="flex-column menu-drawer"
        style={{
          right: activeDrawer === "chapters" ? "1rem" : "-100%",
          minHeight: `calc(100vh - ${headerHeight}px - 2rem)`,
        }}
      >
        <Styled.MenuItem>
          <button onClick={handleGoBack}>
            <IoMdArrowBack /> Main Menu
          </button>
        </Styled.MenuItem>
        <Styled.MenuItem>
          <button onClick={() => handleTopics(slug)}>
            Explore {get(exploreChapter, `title`, "Chapter")}{" "}
            <IoMdArrowForward />
          </button>
        </Styled.MenuItem>
        {chapterMenus.map((link, i) => {
          return link.slug !== slug ? (
            <Col key={"chapter-link" + i}>
              <WMKLink key={"chapter-link" + i} to={"/" + link.slug}>
                {link.title}
              </WMKLink>
            </Col>
          ) : null;
        })}
      </Styled.DrawerLevel2>
      <Styled.DrawerLevel3
        className="flex-column menu-drawer"
        style={{
          right: activeTopic ? "1rem" : "-100%",
          minHeight: `calc(100vh - ${headerHeight}px - 3rem)`,
        }}
      >
        <Styled.MenuItem>
          <button onClick={closeTopic}>
            <IoMdArrowBack /> Back to Chapters
          </button>
        </Styled.MenuItem>
        {activeTopic
          ? activeTopic.map((link, i) => {
              return (
                <Col key={"topic-" + link.slug + i}>
                  <WMKLink to={`/${slug}/${link.slug}`}>{link.title}</WMKLink>
                </Col>
              );
            })
          : null}
      </Styled.DrawerLevel3>
    </Styled.Menus>
  );
};

export const DrawerPages = ({
  menus,
  headerHeight,
  activeDrawer,
  setActiveDrawer,
  pageType,
}) => {
  const handleGoBack = () => {
    setActiveDrawer(pageType);
  };
  return (
    <Styled.Menus>
      <DrawerLevel1
        headerHeight={headerHeight}
        activeMenu={menus[pageType]}
        setActiveDrawer={setActiveDrawer}
        pageType={pageType}
      />
      <Styled.DrawerLevel2
        className="flex-column menu-drawer"
        style={{
          right: activeDrawer === "allChapters" ? "1rem" : "-100%",
          minHeight: `calc(100vh - ${headerHeight}px - 2rem)`,
        }}
      >
        <Styled.MenuItem>
          <button onClick={handleGoBack}>
            <IoMdArrowBack /> Main Menu
          </button>
        </Styled.MenuItem>
        {menus["allChapters"].map((link, i) => {
          return (
            <Styled.MenuItem key={"all" + link.title + i}>
              <WMKLink to={"/" + link.slug}>{link.title}</WMKLink>
            </Styled.MenuItem>
          );
        })}
      </Styled.DrawerLevel2>
    </Styled.Menus>
  );
};

const DrawerLevel1 = ({ headerHeight, activeMenu, pageType }) => {
  return (
    <Styled.DrawerLevel1
      className="flex-column menu-drawer"
      style={{
        minHeight: `calc(100vh - ${headerHeight}px - 1rem)`,
        //top: `calc(${headerHeight}px + 1rem`,
      }}
    >
      {activeMenu
        ? activeMenu.map((link, i) => {
            const MenuItem = menuItems[link.__typename];
            const path = link.entry && link.entry.slug;
            return (
              MenuItem && (
                <Styled.MenuItem key={link.title + i}>
                  <MenuItem
                    action={() => link.action(pageType)}
                    to={"/" + path}
                  >
                    {link.title}
                  </MenuItem>
                </Styled.MenuItem>
              )
            );
          })
        : null}
    </Styled.DrawerLevel1>
  );
};
